import { createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card-header border-0 pt-5" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h3", { class: "card-title align-items-start flex-column" }, [
  /*#__PURE__*/_createVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "New Products"),
  /*#__PURE__*/_createVNode("span", { class: "text-muted mt-1 fw-bold fs-7" }, "Over 500 new products")
], -1)
const _hoisted_3 = { class: "card-toolbar" }
const _hoisted_4 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-color-primary btn-active-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_5 = { class: "svg-icon svg-icon-2" }
const _hoisted_6 = { class: "card-body pt-3" }
const _hoisted_7 = { class: "table-responsive" }
const _hoisted_8 = { class: "\n            table table-row-dashed table-row-gray-300\n            align-middle\n            gs-0\n            gy-4\n          " }
const _hoisted_9 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "border-0" }, [
    /*#__PURE__*/_createVNode("th", { class: "p-0" }),
    /*#__PURE__*/_createVNode("th", { class: "p-0 min-w-150px" }),
    /*#__PURE__*/_createVNode("th", { class: "p-0 min-w-200px" }),
    /*#__PURE__*/_createVNode("th", { class: "p-0 min-w-150px" }),
    /*#__PURE__*/_createVNode("th", { class: "p-0 min-w-100px text-end" })
  ])
], -1)
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = { class: "symbol symbol-45px me-5" }
const _hoisted_12 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_13 = {
  href: "#",
  class: "text-dark fw-bolder text-hover-primary mb-1 fs-6"
}
const _hoisted_14 = {
  href: "#",
  class: "\n                          text-muted text-hover-primary\n                          fw-bold\n                          text-muted\n                          d-block\n                          fs-7\n                        "
}
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "text-dark" }, "Email", -1)
const _hoisted_16 = { class: "text-end" }
const _hoisted_17 = {
  href: "#",
  class: "\n                      text-dark\n                      fw-bolder\n                      text-hover-primary\n                      d-block\n                      mb-1\n                      fs-6\n                    "
}
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "text-muted fw-bold text-muted d-block fs-7" }, "Paid", -1)
const _hoisted_19 = { class: "text-muted fw-bold text-end" }
const _hoisted_20 = { class: "text-end" }
const _hoisted_21 = { class: "text-end" }
const _hoisted_22 = {
  href: "#",
  class: "\n                      btn btn-icon btn-bg-light btn-active-color-primary btn-sm\n                      me-1\n                    "
}
const _hoisted_23 = { class: "svg-icon svg-icon-3" }
const _hoisted_24 = {
  href: "#",
  class: "\n                      btn btn-icon btn-bg-light btn-active-color-primary btn-sm\n                      me-1\n                    "
}
const _hoisted_25 = { class: "svg-icon svg-icon-3" }
const _hoisted_26 = {
  href: "#",
  class: "\n                      btn btn-icon btn-bg-light btn-active-color-primary btn-sm\n                    "
}
const _hoisted_27 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Dropdown2 = _resolveComponent("Dropdown2")!

  return (_openBlock(), _createBlock("div", {
    class: [_ctx.widgetClasses, "card"]
  }, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode("div", _hoisted_3, [
        _createVNode("button", _hoisted_4, [
          _createVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen024.svg" })
          ])
        ]),
        _createVNode(_component_Dropdown2)
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode("div", _hoisted_7, [
        _createVNode("table", _hoisted_8, [
          _hoisted_9,
          _createVNode("tbody", null, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
              return (_openBlock(), _createBlock("tr", { key: index }, [
                _createVNode("td", null, [
                  _createVNode("div", _hoisted_10, [
                    _createVNode("div", _hoisted_11, [
                      (item.user.avatar)
                        ? (_openBlock(), _createBlock("img", {
                            key: 0,
                            alt: "Pic",
                            src: item.user.avatar
                          }, null, 8, ["src"]))
                        : (item.user.state)
                          ? (_openBlock(), _createBlock("span", {
                              key: 1,
                              class: [`bg-light-${item.user.state} text-${item.user.state}`, "symbol-label fw-bolder"]
                            }, _toDisplayString(item.user.name.charAt(0)), 3))
                          : _createCommentVNode("", true)
                    ]),
                    _createVNode("div", _hoisted_12, [
                      _createVNode("a", _hoisted_13, _toDisplayString(item.user.name), 1),
                      _createVNode("a", _hoisted_14, [
                        _hoisted_15,
                        _createTextVNode(": " + _toDisplayString(item.user.email), 1)
                      ])
                    ])
                  ])
                ]),
                _createVNode("td", _hoisted_16, [
                  _createVNode("a", _hoisted_17, _toDisplayString(item.price), 1),
                  _hoisted_18
                ]),
                _createVNode("td", _hoisted_19, _toDisplayString(item.technologies), 1),
                _createVNode("td", _hoisted_20, [
                  _createVNode("span", {
                    class: [`badge-light-${item.status.color}`, "badge"]
                  }, _toDisplayString(item.status.label), 3)
                ]),
                _createVNode("td", _hoisted_21, [
                  _createVNode("a", _hoisted_22, [
                    _createVNode("span", _hoisted_23, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen019.svg" })
                    ])
                  ]),
                  _createVNode("a", _hoisted_24, [
                    _createVNode("span", _hoisted_25, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/art/art005.svg" })
                    ])
                  ]),
                  _createVNode("a", _hoisted_26, [
                    _createVNode("span", _hoisted_27, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen027.svg" })
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ], 2))
}